import api from './base'

export default {
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/locations`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/locations/${id}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/locations`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/locations/${id}`)
  },
  setSortOrder ({ businessUnitId, locationId, sortOrder }) {
    return api().put(`company/business_units/${businessUnitId}/locations/${locationId}/sort_order`, { sort_order: sortOrder })
  }
}
